import { render, staticRenderFns } from "./product-edit.vue?vue&type=template&id=c373a564&scoped=true"
import script from "./product-edit.vue?vue&type=script&lang=js"
export * from "./product-edit.vue?vue&type=script&lang=js"
import style0 from "./product-edit.vue?vue&type=style&index=0&id=c373a564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c373a564",
  null
  
)

export default component.exports